import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import { updateNotificationToken } from "../api/api";
import { firebaseConfig } from "./FirebaseConfig";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getFirebaseToken = () => {
  return getToken(messaging, {
    vapidKey:
      "BMtIYhzFVedyBPET9hUl4jd4GRbFTMCN50k62DBegPLVW4KPlyPIXhyUlzgfdeeN4bteIexVoxBds5nhw69-0jk",
  })
    .then((currentToken) => {
      if (currentToken) {
        updateNotificationToken(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onFirebaseMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
